import Item from './Item'
import Line from './Line'
import { Box, OldHeading, breakpoints } from '@gassan-ui'
import { getDataCodenameValues } from '@lib/getDataCodenameValues'
import { SingleItemResponse } from '@lib/kontent'
import { TourPage } from '@lib/kontent/models/TourPage'
import { FC } from 'react'
import styled from 'styled-components'

const Grid = styled.div`
  @media screen and (min-width: ${breakpoints.large}) {
    columns: 2;
    column-gap: 12rem;
  }
`

const Highlights: FC<SingleItemResponse<TourPage>> = (props) => {
  const items = getDataCodenameValues(props.item.elements.highlights.value).map(
    (key) => props.modular_content[key].elements,
  )
  return (
    <Box position="relative" mb={{ _: '2.5rem', medium: '3rem' }}>
      <Line />
      <OldHeading variant="h2" as="h2" mb=".5rem">
        Tour Highlights
      </OldHeading>
      <OldHeading variant="h4" as="h4" color="shades.500">
        {props.item.elements.title.value}
      </OldHeading>
      <Grid>
        {items.map((item, index) => (
          <Item key={index} index={index} total={items.length} {...item} />
        ))}
      </Grid>
    </Box>
  )
}

export default Highlights
